/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import fhpCalcConfig from "../config/fhpCalculator.config.json";
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from "../../state-machine";
import { CoverageCalculatorMessage, PremiumCalculatorMessage } from "../messages";
import { PREMIUM_CALCULATOR_CONFIG } from "../machines/premium-calculator";
import { COVERAGE_CALCULATOR_CONFIG } from "../machines/coverage-calculator";

export interface IFHPCalculatorServiceMethods extends IPluginMethodMap {
  coverageToPremiumSync(args: {
    coverage: number;
    country: TSupportedCountries;
    discount: number;
  }): any;
  premiumToCoverageSync(args: {
    premium: number;
    country: TSupportedCountries;
    discount: number;
  }): any;
}

export type TSupportedCountries = "dm" | "gd";

export class FHPCalculatorService
  extends AppServiceRequestProcessor
  implements IAgentPlugin
{
  readonly methods: IFHPCalculatorServiceMethods;

  constructor() {
    super();
    this.methods = {
      coverageToPremiumSync: this.coverageToPremiumSync.bind(this),
      premiumToCoverageSync: this.premiumToCoverageSync.bind(this),
    };
  }

  coverageToPremiumSync({
    coverage,
    country,
    discount
  }: {
    coverage: number;
    country: TSupportedCountries;
    discount: number
  }) {
    // const countryFound = fhpCalcConfig[country];
    // if (!countryFound) {
    //   throw Error(`unsupported country ${country} for this product`);
    // }
    // const formatter = new Intl.NumberFormat(
    //   countryFound?.currencyFormat?.locale,
    //   {
    //     style: "currency",
    //     currency: countryFound?.currencyFormat?.currency,
    //   }
    // );
    // const result: any = {
    //   country: country,
    //   coverage: {
    //     raw: coverage,
    //     formatted: formatter.format(coverage),
    //   },
    //   policyOptions: [...(countryFound.policyOptions || [])],
    // };
    // if (result) {
    //   result?.policyOptions?.forEach((opt: any, opti: number) => {
    //     const rol = opt.rolPct;
    //     const _premium = coverage * (rol / 100);
    //     opt.premium = {
    //       raw: _premium,
    //       formatted: formatter.format(_premium),
    //     };
    //     opt?.triggeringParams?.forEach((tp: any, tpi: number) => {
    //       const tpCoverage = coverage * (tp.coveragePct / 100);
    //       tp.coverage = {
    //         raw: tpCoverage,
    //         formatted: formatter.format(tpCoverage),
    //       };
    //     });
    //   });
    // }
    const message = new PremiumCalculatorMessage({
      coverage,
      country,
      discount
    });
    this.startSyncProcessing({
      machineConfig: {
        ...PREMIUM_CALCULATOR_CONFIG,
        data: {
          message: message,
        },
      },
      machineType: AppServiceMachineType.CALCULATE_PREMIUM,
    });
    // return result;
    return message.totalPremium;
  }

  premiumToCoverageSync({
    premium,
    country,
    discount
  }: {
    premium: number;
    country: TSupportedCountries;
    discount: number
  }) {
    // const countryFound = fhpCalcConfig[country];
    // if (!countryFound) {
    //   throw Error(`unsupported country ${country} for this product`);
    // }
    // const formatter = new Intl.NumberFormat(
    //   countryFound?.currencyFormat?.locale,
    //   {
    //     style: "currency",
    //     currency: countryFound?.currencyFormat?.currency,
    //   }
    // );
    // const result: any = {
    //   country: country,
    //   premium: {
    //     raw: premium,
    //     formatted: formatter.format(premium),
    //   },
    //   policyOptions: [...(countryFound.policyOptions || [])],
    // };
    // if (result) {
    //   result?.policyOptions?.forEach((opt: any, opti: number) => {
    //     const rol = opt.rolPct;
    //     const _coverage = premium * (100 / rol);
    //     opt.coverage = {
    //       raw: _coverage,
    //       formatted: formatter.format(_coverage),
    //     };
    //     opt?.triggeringParams?.forEach((tp: any, tpi: number) => {
    //       const tpPremium = _coverage * (tp.coveragePct / 100);
    //       tp.coverage = {
    //         raw: tpPremium,
    //         formatted: formatter.format(tpPremium),
    //       };
    //     });
    //   });
    // }
    // return result;


    const message = new CoverageCalculatorMessage({
      premium,
      country,
      discount
    });
    this.startSyncProcessing({
      machineConfig: {
        ...COVERAGE_CALCULATOR_CONFIG,
        data: {
          message: message,
        },
      },
      machineType: AppServiceMachineType.CALCULATE_PREMIUM,
    });
    // return result;
    return message.totalCoverage;
  }
}
